import { PagePartHolder } from '../../PagePartHolder';

export const SavebarHolder = (props) => {
  return <PagePartHolder {...props} outlet="save" />;
};
